module.exports = __webpack_public_path__ + "static/media/hasta.511c3370.jpg";